import http from "./axios";

const systemFormDataPage = ({
  phone,
  pageNo,
  pageSize,
  startTime,
  endTime,
  param,
  modelId,
}) => {
  return http.get("/manager/formData/systemFormDataPage", {
    phone,
    pageNo,
    pageSize,
    startTime,
    endTime,
    param,
    modelId,
  });
};

const platformFormDataPage = ({
  phone,
  pageNo,
  pageSize,
  startTime,
  endTime,
  platformId,
  param,
  modelId,
}) => {
  return http.get("/manager/formData/platformFormDataPage", {
    phone,
    pageNo,
    pageSize,
    startTime,
    endTime,
    platformId,
    param,
    modelId,
  });
};

const systemFormDataSearchParam = ({ modelId }) => {
  return http.get("/manager/formData/systemFormDataSearchParam", { modelId });
};

const platformFormDataSearchParam = ({ platformId, modelId }) => {
  return http.get("/manager/formData/platformFormDataSearchParam", {
    platformId,
    modelId,
  });
};

export default {
  systemFormDataPage,
  platformFormDataPage,
  systemFormDataSearchParam,
  platformFormDataSearchParam,
};
